import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import getEnvironmentTheme from '../../theme/environmentTheme';

const styles = theme => ({
  environmentBanner: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    backgroundColor: theme.palette.primary.main,
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    fontWeight: 'bold',
    color: 'white',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
  },
  environmentText: {
    backgroundColor: theme.palette.primary.main,
    padding: '2px 8px',
    borderRadius: '0 0 4px 4px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
  },
});

const EnvironmentIndicator = ({ classes }) => {
  const theme = getEnvironmentTheme();
  
  // Only show for non-production environments
  if (theme.isProduction) {
    return null;
  }

  return (
    <div className={classes.environmentBanner}>
      <div className={classes.environmentText}>
        {theme.environment}
      </div>
    </div>
  );
};

EnvironmentIndicator.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EnvironmentIndicator); 